import viewName from '../constant.js'
import {
    getCarLine
} from '@/models/carLineSelect'

export default {
    name: viewName.carLineSelect,
    inject: ['showLoading', 'hideLoading'],
    data () {
        return {
            brand_id: '',
            brand_name: '',
            lineList: []
        }
    },
    async created () {
        this.$emit('setHeader', {
            title: '选择车系',
            showHeader: true,
            showLeft: true
        })
        this.brand_id = this.$route.query.brand_id
        this.brand_name = this.$route.query.brand_name
        await this.getCarLineList()
    },
    methods: {
        getCarLineList () {
            this.showLoading()
            getCarLine({brand_id: this.brand_id}).then((res) => {
                this.hideLoading()
                this.lineList = res
            })
        }
    }
}
